import { CatActionTypes } from './cat.types';
import { formatCategoryData } from './cat.utils';

const INITIAL_STATE = {
  existingCategories: null
};

const catReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CatActionTypes.SET_EXISTING_CATEGORIES:
      return {
        ...state,
        existingCategories: formatCategoryData(action.payload)
      };
    default:
      return state;
  }
};

export default catReducer;